(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["abs-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
  const link = document.getElementById('abs-whatsapp');
  const proxy = document.getElementById('abs-live-chat');
  if (!link || !proxy) return;
  proxy.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    const runtime = root?.querySelector('shopify-agent-runtime');
    const activator = runtime?.shadowRoot?.querySelector('button.activator') || root?.querySelector('button.activator');
    if (runtime) {
      runtime.setAttribute('open', '');
    } else if (activator?.isConnected) {
      activator.click();
    }
  });
  const observed = new WeakSet();
  const measured = new WeakSet();
  let pending = false;
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  }
  function observeRoot(root) {
    if (!root || observed.has(root)) return;
    observed.add(root);
    const style = document.createElement('style');
    style.textContent = '.activator{visibility:hidden!important;pointer-events:none!important}:host{position:fixed!important;inset:0!important;transform:none!important;translate:none!important;scale:1!important;transition:none!important;animation:none!important;contain:none!important}#shopify-element-wrapper{transform:none!important;translate:none!important;transition:none!important;animation:none!important;contain:none!important}.activator__label,.activator__icon{color:#000!important;-webkit-text-fill-color:#000!important}.activator{--activator-fg:#000!important;--activator-bg:#fff!important}.activator-nudge{position:static!important;transform:none!important;translate:none!important;animation:none!important;transition:none!important}.activator{position:fixed!important;top:auto!important;left:auto!important;right:var(--abs-contact-right,20px)!important;bottom:var(--abs-contact-bottom,24px)!important;background:#fff!important;color:#000!important;border:0!important;border-radius:12px!important;box-shadow:0 0 14px rgb(0 0 0 / .5)!important;transform:none!important;translate:none!important;scale:1!important;animation:none!important;transition:background-color .15s!important;min-height:50px!important}.activator:hover{background:#f5f5f5!important}';
    root.appendChild(style);
    new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['open','aria-expanded']});
  }
  function update() {
    pending = false;
    const host = document.querySelector('shopify-chat');
    observeRoot(host?.shadowRoot);
    const runtime = host?.shadowRoot?.querySelector('shopify-agent-runtime');
    observeRoot(runtime?.shadowRoot);
    const button = host?.shadowRoot?.querySelector('button.activator') || runtime?.shadowRoot?.querySelector('button.activator');
    link.hidden = Boolean(runtime?.hasAttribute('open') || button?.getAttribute('aria-expanded') === 'true');
    proxy.hidden = link.hidden || !button;
    if (!button) return;
    const label = button.getAttribute('aria-label') || button.textContent.trim();
    proxy.setAttribute('aria-label',label);
    const caption = proxy.querySelector('span');
    if (caption.textContent !== label) caption.textContent = label;
    if (!measured.has(button)) {
      measured.add(button);
      new ResizeObserver(schedule).observe(button);
    }
    if (proxy.offsetWidth) document.documentElement.style.setProperty('--abs-chat-width',proxy.offsetWidth + 'px');
    link.style.fontFamily = getComputedStyle(button).fontFamily;
    proxy.style.fontFamily = getComputedStyle(button).fontFamily;
  }
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  addEventListener('resize',schedule,{passive:true});
  schedule();
  setTimeout(schedule,1000);
  setTimeout(schedule,3000);
  setTimeout(schedule,8000);
})();
  } catch(e) { console.error(e); }
})();

})();
